export const getCompaniesRouteEndpoint = '/price-calculator/companies';
export const createCompanyRouteEndpoint = '/price-calculator/companies';
export const getCompanyRouteEndpoint = '/price-calculator/companies/{companyId}';
export const updateCompanyRouteEndpoint = '/price-calculator/companies/{companyId}';
export const deleteCompanyRouteEndpoint = '/price-calculator/companies/{companyId}';
export const getProjectsRouteEndpoint = '/price-calculator/projects';
export const createProjectRouteEndpoint = '/price-calculator/projects';
export const getProjectRouteEndpoint = '/price-calculator/projects/{projectId}';
export const updateProjectRouteEndpoint = '/price-calculator/projects/{projectId}';
export const deleteProjectRouteEndpoint = '/price-calculator/projects/{projectId}';
export const getCalculationRevisionRouteEndpoint = '/price-calculator/calculations/{projectId}';
export const getAppGroupsEndpoint = '/price-calculator/app/groups';
export const getPriceCalculatorSettingsRouteEndpoint = '/price-calculator/settings';
export const setPriceCalculatorSettingsRouteEndpoint = '/price-calculator/settings';
export const getUsersPublicInfoRouteEndpoint = '/price-calculator/users/public-info';
